import { parseByCountry } from "./FormatInputByCountry";

export const normalizePayloadNumber = (schema: any, form: any): any => {
  if (Array.isArray(schema)) {
    return Array.isArray(form)
      ? form.map((item) => normalizePayloadNumber(schema[0] ?? {}, item))
      : form;
  }

  if (schema && typeof schema === "object") {
    return Object.keys(schema).reduce(
      (result: any, key) => {
        const schemaVal = schema[key];
        const value = form?.[key];

        if (typeof schemaVal === "number") {
          result[key] =
            typeof value === "string" ? parseByCountry(value) : (Number(value) || 0);
        } else {
          result[key] = normalizePayloadNumber(schemaVal, value);
        }

        return result;
      },
      { ...form }
    );
  }

  return form;
};

export const toNumber = (value: any): number => {
  if (!value) return 0;

  if (typeof value === "string") {
    return parseByCountry(value);
  }

  return value;
};
